export default "__VITE_ASSET__caca0b4a__"